// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as PricingDashboardAssetsManager from "../../../assets/PricingDashboardAssetsManager.bs.js";

var modal_close_cross = PricingDashboardAssetsManager.getImage("modal-close.svg");

function ConfirmationModal(Props) {
  var title = Props.title;
  var isOpen = Props.isOpen;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  var confirm_button_title = Props.confirm_button_title;
  var cancel_button_title = Props.cancel_button_title;
  var children = Props.children;
  return React.createElement(ReactModal, {
              isOpen: isOpen,
              onRequestClose: (function (param) {
                  
                }),
              overlayClassName: "modal-overlay",
              className: "modal-content",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "c-confirmation-modal"
                  }, React.createElement("div", {
                        className: "title-bar"
                      }, React.createElement("div", {
                            className: "title"
                          }, title), React.createElement("div", {
                            className: "close-btn",
                            onClick: (function (param) {
                                return Curry._1(onCancelCb, undefined);
                              })
                          }, React.createElement("img", {
                                src: modal_close_cross
                              }))), React.createElement("div", {
                        className: "body"
                      }, children), React.createElement("div", {
                        className: "footer"
                      }, React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Text */0,
                                  _0: cancel_button_title
                                }, undefined, (function (param) {
                                    return Curry._1(onCancelCb, undefined);
                                  }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                          }), React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Text */0,
                                  _0: confirm_button_title
                                }, undefined, (function (param) {
                                    return Curry._1(onConfirmCb, undefined);
                                  }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                          })))
            });
}

var make = ConfirmationModal;

export {
  modal_close_cross ,
  make ,
  
}
/* modal_close_cross Not a pure module */
